<section class="main-section">
  <a id="home" class="anchor"></a>
  <div class="container">
    <div class="centered-wrap">
      <h1 [innerHTML]="'HOME.GIPANT.MAIN_TITLE' | translate"></h1>
      <div class="pickup-address-wrap">
        <div class="form-group">
          <i class="icon icon-subtract"></i>
          <input type="text"
                 [placeholder]="'HOME.GIPANT.ENTER_YOUR_ADDRESS' | translate"
                 [ngModel]="pickUpAddress"
                 (input)="onAddressSearch($event)"/>
          <ul *ngIf="addressSuggestions.length" class="suggestions-list">
            <li *ngFor="let suggestion of addressSuggestions"
                (click)="selectAddress(suggestion);">
              <span class="main-text">{{ suggestion.mainText }}</span>
              <span class="secondary-text">{{ suggestion.secondaryText }}</span>
            </li>
          </ul>
          <button class="address-btn" (click)="goToForm()">
            <span class="loader" *ngIf="loadingAddress"></span>
            <i class="icon icon-arrow-right" *ngIf="!loadingAddress"></i>
          </button>
        </div>
      </div>
    </div>

  </div>

  <div class="sports-wrap">
    <div class="sports-line top-line">
      <div class="sports-line-inner">

        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/1.svg" width="47" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/2.svg" width="45" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/3.svg" width="47" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/4.svg" width="50" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/5.svg" width="31" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/6.svg" width="25" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/7.svg" width="58" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/8.svg" width="56" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/9.svg" width="59" height="19" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/10.svg" width="60" height="53" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/11.svg" width="60" height="45" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/12.svg" width="60" height="50" loading="lazy" alt=""></div>

        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/1.svg" width="47" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/2.svg" width="45" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/3.svg" width="47" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/4.svg" width="50" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/5.svg" width="31" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/6.svg" width="25" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/7.svg" width="58" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/8.svg" width="56" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/9.svg" width="59" height="19" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/10.svg" width="60" height="53" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/11.svg" width="60" height="45" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/12.svg" width="60" height="50" loading="lazy" alt=""></div>

        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/1.svg" width="47" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/2.svg" width="45" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/3.svg" width="47" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/4.svg" width="50" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/5.svg" width="31" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/6.svg" width="25" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/7.svg" width="58" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/8.svg" width="56" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/9.svg" width="59" height="19" loading="lazy" alt=""></div>

      </div>
    </div>
    <div class="sports-line bottom-line">
      <div class="sports-line-inner">
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/13.svg" width="22" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/14.svg" width="60" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/15.svg" width="51" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/16.svg" width="25" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/1.svg" width="47" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/3.svg" width="47" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/2.svg" width="45" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/4.svg" width="50" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/6.svg" width="25" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/5.svg" width="31" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/7.svg" width="58" height="59" loading="lazy" alt=""></div>

        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/13.svg" width="22" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/14.svg" width="60" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/15.svg" width="51" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/16.svg" width="25" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/1.svg" width="47" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/3.svg" width="47" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/2.svg" width="45" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/4.svg" width="50" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/6.svg" width="25" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/5.svg" width="31" height="59" loading="lazy" alt=""></div>
        <div class="item" [class.glass--ready]="blurReady"><img ngSrc="assets/images/sports/7.svg" width="58" height="59" loading="lazy" alt=""></div>
      </div>
    </div>
  </div>

</section>

<section id="pick-up-request-form-section">
  <a id="pick-up-request" class="anchor"></a>
  <div class="container">
    <app-pickup-request-form [selectedAddressData]="selectedAddress" ></app-pickup-request-form>
  </div>
</section>

<section id="how-works">
  <a id="how-it-works" class="anchor"></a>
  <div class="container">
    <app-how-works [giPantMode]="true"></app-how-works>
  </div>
</section>

<section id="features-section">
  <a id="features" class="anchor"></a>
  <div class="container">
    <app-features [giPantMode]="true" [endConsumerMode]="true"></app-features>
  </div>
</section>

<section id="call-to-action">
  <div class="container">
    <app-call-to-action [giPantMode]="true"></app-call-to-action>
  </div>
</section>

<section id="reviews">
  <a id="about-us" class="anchor"></a>
  <div class="container">
    <app-reviews [giPantMode]="true"></app-reviews>
  </div>
</section>

<section id="download">
  <div class="container">
    <app-download [giPantMode]="true"></app-download>
  </div>
</section>

<section id="contact-form">
  <a id="contact-us" class="anchor"></a>
  <div class="container">
    <app-contact-form [giPantMode]="true"></app-contact-form>
  </div>
</section>

